import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
  RECAPTCHA_LANGUAGE
} from 'ng-recaptcha';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

import { AgmCoreModule } from '@agm/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/pages.components/home.component/home.component';
import { AboutComponent } from './components/pages.components/about.component/about.component';
import { ContactComponent } from './components/pages.components/contact.component/contact.component';
import { ArticlesComponent } from './components/articles.components/articles.component/articles.component';
import { ArticleDetailsComponent } from './components/articles.components/articleDetails.component/articleDetails.component';
import { BlogsComponent } from './components/blogs.components/blogs.component/blogs.component';
import { BlogDetailsComponent } from './components/blogs.components/blogDetails.component/blogDetails.component';
import { VideosComponent } from './components/videos.components/videos.component/videos.component';
import { VideoDetailsComponent } from './components/videos.components/videoDetails.component/videoDetails.component';
import { GaleryComponent } from './components/galeries.components/galery.component/galery.component';
import { ColleaguesComponent } from './components/galeries.components/colleagues.component/colleagues.component';
import { EquipmentComponent } from './components/galeries.components/equipment.component/equipment.component';
import { InsurancesComponent } from './components/partners.components/insurances.component/insurances.component';
import { CompaniesComponent } from './components/partners.components/companies.component/companies.component';
import { OnlineAnsweringComponent } from './components/onlineServices.components/onlineAnswering.component/onlineAnswering.component';
import { ArticleService } from './services/article.service';
import { BlogService } from './services/blog.service';
import { VideoService } from './services/video.service';
import { VideoPlayerComponent } from './components/videos.components/videoPlayer.component/videoPlayer.component';
import { PartnerOrganizationService } from './services/partnerOrganization.service';
import { PartnerCompanyService } from './services/partnerCompany.service';
import { CommonPageService } from './services/commonPage.service';
import { GoogleMapComponent } from './components/pages.components/googleMap.component/googleMap.component';
import { CommonInformationService } from './services/commonInformation.service';
import { FAQService } from './services/faq.service';
import { FAQComponent } from './components/faq.components/faq.component/faq.component';
import { CompanyEmployeeService } from './services/companyEmploee.service';
import { CompanyEquipmentService } from './services/companyEquipment.service';
import { PhotoGaleryService } from './services/photoGalery.service';
import { SocialNetworkLinkService } from './services/socialNetworkLink.service';
import { UsefulLinkService } from './services/usefulLink.service';
import { OnlineAnswerService } from './services/onlineanswer.service';
import { PaymentSucceededComponent } from './components/onlineServices.components/paymentSucceeded.component/paymentSucceeded.component';
import { PaymentFailureComponent } from './components/onlineServices.components/paymentFailure.component/paymentFailure.component';
import { SuggestionService } from './services/suggestion.service';
import { SendSuggestionComponent } from './components/suggestion.components/sendSuggestion.component';
import { VersionComponent } from './components/pages.components/version.component/version.component';
import { PhotoGaleryGroupService } from './services/photoGaleryGroup.service';
import { PageService } from './services/page.service';
import { PageComponent } from './components/page.component/page.component';
import { AwardService } from './services/award.service';
import { AwardsComponent } from './components/awards.components/awards.component/awards.component';
import { AwardDetailsComponent } from './components/awards.components/awardDetails.component/awardDetails.component';
import { TestService } from './services/test.service';
import { TestDetailsComponent } from './components/tests.components/testDetails.component/testDetails.component';
import { TestsComponent } from './components/tests.components/tests.component/tests.component';
import { GoalsComponent } from './components/pages.components/goals.component/goals.component';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';
import { Notfound404Component } from './components/pages.components/notfound404.component/notfound404.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'About', component: AboutComponent },
  { path: 'Contact', component: ContactComponent },
  { path: 'Articles/Page/:id', component: ArticlesComponent },
  { path: 'Articles/:id', component: ArticleDetailsComponent },
  { path: 'Blogs/Page/:id', component: BlogsComponent },
  { path: 'Blogs/:id', component: BlogDetailsComponent },
  { path: 'Videos/Page/:id', component: VideosComponent },
  { path: 'Videos/:id', component: VideoDetailsComponent },
  { path: 'Galery/:id', component: GaleryComponent },
  { path: 'Colleagues', component: ColleaguesComponent },
  { path: 'Equipments', component: EquipmentComponent },
  { path: 'Insurances', component: InsurancesComponent },
  { path: 'Companies', component: CompaniesComponent },
  { path: 'OnlineAnswering', component: OnlineAnsweringComponent },
  { path: 'FAQ', component: FAQComponent },
  { path: 'PaymentSucceeded', component: PaymentSucceededComponent },
  { path: 'PaymentFailure', component: PaymentFailureComponent },
  { path: 'Version', component: VersionComponent },
  { path: 'Pages/:id', component: PageComponent },
  { path: 'Awards/Page/:id', component: AwardsComponent },
  { path: 'Awards/:id', component: AwardDetailsComponent },
  { path: 'Tests/Page/:id', component: TestsComponent },
  { path: 'Tests/:id', component: TestDetailsComponent },
  { path: 'Goals', component: GoalsComponent },
  { path: "404", component: Notfound404Component },
  { path: "**", redirectTo: "/404" },
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    ArticlesComponent,
    ArticleDetailsComponent,
    BlogsComponent,
    BlogDetailsComponent,
    VideosComponent,
    VideoDetailsComponent,
    GaleryComponent,
    ColleaguesComponent,
    EquipmentComponent,
    InsurancesComponent,
    CompaniesComponent,
    OnlineAnsweringComponent,
    VideoPlayerComponent,
    GoogleMapComponent,
    FAQComponent,
    PaymentSucceededComponent,
    PaymentFailureComponent,
    SendSuggestionComponent,
    VersionComponent,
    PageComponent,
    AwardsComponent,
    AwardDetailsComponent,
    TestDetailsComponent,
    TestsComponent,
    GoalsComponent,
    SafeHtmlPipe,
    Notfound404Component
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyABLca68xLnByGMJ7D56T5Mb2PmslGynq4'
    }),
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: '6Lcm-mYUAAAAAL0OMyYlG5JfyA1C7uDuFqgXijXz'
      } as RecaptchaSettings
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'fa'
    },
    ArticleService,
    BlogService,
    VideoService,
    PartnerOrganizationService,
    PartnerCompanyService,
    CommonPageService,
    CommonInformationService,
    FAQService,
    CompanyEmployeeService,
    CompanyEquipmentService,
    PhotoGaleryService,
    SocialNetworkLinkService,
    UsefulLinkService,
    OnlineAnswerService,
    SuggestionService,
    PhotoGaleryGroupService,
    PageService,
    AwardService,
    TestService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
